export const TRAM_PLAN_CONFIGS = {
  edi: {
    key: 'edi',
    name: 'Edinburgh',
    route: '/edi-tram-plan',
    mapEngine: 'legacy-rail-network',
    defaultView: {
      lng: -3.188267,
      lat: 55.953252,
      zoom: 11,
      bearing: 0,
      pitch: 0,
    },
    autoSwitchZone: {
      center: { lng: -3.188267, lat: 55.953252 },
      radiusKm: 90,
      minZoom: 5.2,
    },
    description: 'Interactive Edinburgh tram and rail plan',
  },
  leeds: {
    key: 'leeds',
    name: 'Leeds',
    route: '/leeds-tram-plan',
    mapEngine: 'geojson',
    defaultTheme: 'light',
    defaultMapStyle: 'planet',
    defaultView: {
      lng: -1.605,
      lat: 53.785,
      zoom: 10.2,
      bearing: 0,
      pitch: 0,
    },
    autoSwitchZone: {
      center: { lng: -1.605, lat: 53.785 },
      radiusKm: 100,
      minZoom: 5.2,
    },
    legendTitle: 'Leeds / Bradford Options',
    description: 'Interactive Leeds and West Yorkshire mass transit options map',
    dataPaths: {
      lines: 'data/tramPlans/leeds/lines.geojson',
      stations: 'data/tramPlans/leeds/stations.geojson',
      bounds: 'data/tramPlans/leeds/bounds.json',
      sources: 'data/tramPlans/leeds/SOURCES.md',
    },
    disclaimer:
      'Indicative alignment based on WYCA consultation maps and route-option appendices. Final alignments and stop locations are not yet confirmed.',
  },
};

export const TRAM_PLAN_NAV_ORDER = ['edi', 'leeds'];

export function getTramPlanConfig(cityKey, options = {}) {
  void options;
  return TRAM_PLAN_CONFIGS[cityKey] || null;
}

export function getTramPlanNavItems(options = {}) {
  const { includeDisabled = false } = options;
  return TRAM_PLAN_NAV_ORDER.map((cityKey) => {
    const config = TRAM_PLAN_CONFIGS[cityKey];
    if (!config) return null;
    if (!includeDisabled && config.disabled === true) return null;
    return {
      key: config.key,
      label: `Tram Plan: ${config.name}`,
      href: config.route,
    };
  }).filter(Boolean);
}
